import React from "react";

export default function DashboardPage() {
    return <section className="">DashboardPage</section>;
}
